



































































































import Vue from 'vue';
import VatsAPI from '@/Shared/VatsAPI';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import { DiagnosticCnts } from './DiagnosticCnts';
// import { getValidationErrors } from '@/Shared/ValidationErrorDirective';
import mixins from 'vue-typed-mixins';

const DiagnosticCounts = mixins(LocationBasedMixin).extend({
    data() {
        return {
            loading: false,
            diagnosticCounts: [] as DiagnosticCnts[],
            validationErrors: {} as { [key: string]: string[] },
        };
    },
    methods: {
        async refreshCounts() {
            try {
                this.diagnosticCounts = (await VatsAPI.get<DiagnosticCnts[]>(`/${this.location}/DiagnosticCounts/GetDiagnosticCounts`)).data;
            }
            catch (e) {
                this.$bvToast.toast(this.$i18n.t('admin.diagnosticCounts.refreshDiagnosticError').toString(), {
                    title: this.$i18n.t('common.error').toString(),
                    autoHideDelay: 5000
                });
                throw e;
            }
        },
        async locationChanged() {
            await this.refreshCounts();
        },
    },
    computed: {
        lookupstotal(): number {
            return this.diagnosticCounts.reduce((tot, dcount) => {
                return tot + (dcount.lookups != null ? dcount.lookups : 0);
            }, 0);
        },
        citationstotal(): number {
            return this.diagnosticCounts.reduce((tot, dcount) => {
                return tot + (dcount.citations != null ? dcount.citations : 0);
            }, 0);
        },
        paymentstotal(): number {
            return this.diagnosticCounts.reduce((tot, dcount) => {
                return tot + (dcount.payments != null ? dcount.payments : 0);
            }, 0);
        },
        escalationstotal(): number {
            return this.diagnosticCounts.reduce((tot, dcount) => {
                return tot + (dcount.escalations != null ? dcount.escalations : 0);
            }, 0);
        },
        letterstotal(): number {
            return this.diagnosticCounts.reduce((tot, dcount) => {
                return tot + (dcount.letters != null ? dcount.letters : 0);
            }, 0);
        },
        emailstotal(): number {
            return this.diagnosticCounts.reduce((tot, dcount) => {
                return tot + (dcount.emails != null ? dcount.emails : 0);
            }, 0);
        }
    },
    filters: {
        formatPayment(value: string) {
            if (!value) {
                return '0.00';
            }
            return parseFloat(value).toFixed(2);
        }
    },
    async mounted() {
        this.loading = true;
        this.refreshCounts();
        this.loading = false;
    }
});

export default DiagnosticCounts;

